<template>
  <div id="app">
    <div id="decoration_bar">
      <div class="decoration" v-for="n of decorations_number" :key="n"></div>
    </div>
    <section id="top">
      <Title
        class="top_title"
        titleWord="Namuyu."
        subMessage="I’m a software developer."
        barColor="#9be240"
      />
    </section>
    <section id="about" class="main_contents">
      <Title titleWord="ABOUT" subMessage="Hi, I’m Namuyu." barColor="#e89053" />
      <div class="cols">
        <div id="introduce" class="col_2rows">
          <h4>Let me introduce myself.</h4>
          <p>
            I’m a software engineer who is interested in creating web applications.
            <br />My mejor in university was economy, especially interested in economatrics.
            <br />And I tried some times to create original videogame with Unity.
            <br />For these backgroud, I started my career as a software engineer.
            <br />I usually use C# as primary language for developing, but I can use JavaScript also.
            <br />Currently, I’m interested in frontend engineering and learning frontend frameworks.
            <br />Always enjoying learning new things, and writing
            <a
              href="https://namyusql.hatenablog.com/"
            >blogs</a> to share what I learned.
            <br />I'm not looking for freelance opportunities currently, but you can always catch me on my
            <a
              href="https://twitter.com/namuyuy"
            >Twitter</a> or
            <a href="https://github.com/Namuyu">Github</a>, or
            <a href="https://namyusql.hatenablog.com/">Hatena blog</a>.
          </p>
        </div>
        <div id="interested" class="col_2rows">
          <h4>I’m interested in...</h4>
          <ul>
            <li>Creating Web Application(HTML, CSS, .NET, Blazor, Node</li>
            <li>js, Vue.js, React, etc...)</li>
            <li>Web Design</li>
            <li>Architecture(Microservice, Distributed system, DDD, etc..)</li>
            <li>Cloud Solutions(Azure, AWS, GCP)</li>
            <li>Database(SQL Server, My SQL, Mongo DB, etc..)</li>
            <li>Creating video games(especially Unity)</li>
            <li>Statistics</li>
            <li>Web Application Security</li>
          </ul>
        </div>
      </div>
      <div class="cols">
        <div class="col_2rows">
          <img src />
        </div>
        <div id="qualification" class="col_2rows">
          <h4>Qualification</h4>
          <ul>
            <li>基本情報処理技術者</li>
            <li>IT パスポート</li>
            <li>統計検定2級（JSSC)</li>
            <li>MCP-532 Developing Microsft Azure Solutions</li>
            <li>MCP-533 Implementing Microsoft Azure Infrastructure Solutions</li>
            <li>MCSA Cloud Platform - Certified 2018</li>
          </ul>
        </div>
      </div>
    </section>
    <section id="creations" class="main_contents">
      <Title titleWord="CREATIONS" subMessage="What I developed, created." barColor="#317393" />
      <div class="cols">
        <div id="github" class="col_3rows">
          <h4>Github</h4>
          <Colorbar barColor="#303424" />
          <p>Coming soon...</p>
        </div>
        <div id="unity" class="col_3rows">
          <h4>Unity room</h4>
          <Colorbar barColor="#a3e055" />
          <p>Coming soon...</p>
        </div>
        <div id="website" class="col_3rows">
          <h4>WebSite</h4>
          <Colorbar barColor="#e89053" />
          <img
            src="https://firebasestorage.googleapis.com/v0/b/namuyu-s-portfolio.appspot.com/o/fav.png?alt=media&token=18a665e2-31ed-403e-886d-e4180d0d1024"
          />
          <p>This portfolio site.</p>
        </div>
      </div>
    </section>
    <section id="blogs" class="main_contents">
      <Title titleWord="BLOGS" subMessage="Posts from my Blog." barColor="#993137" />
      <div class="cols">
        <div class="col_both_ends">
          <a href="https://namyusql.hatenablog.com/entry/2019/03/29/080405">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/namuyu-s-portfolio.appspot.com/o/blog4.jpg?alt=media&token=477c39be-4e93-4eb6-8de0-e580df1e73a5"
            />
          </a>
          <h4>
            AzureにRedmineを立てて
            <br />githubと連携する方法
          </h4>
          <p class="date">2019/3/29</p>
          <p>社内で使っていたredmineでタスクの内容とgithubのコード変更を結び付け、トレースできるようにするため。 本番環境でいきなり試すわけにはいかないのでDockerを使ってみたり色々試したのち、AzureのVMでやるとうまくいったので。 「redmineとgithubの連携を試したいけどどんな環境でやればいいの」という人に使えるかもです。</p>
        </div>
        <div class="col_both_ends">
          <a href="https://namyusql.hatenablog.com/entry/2018/10/16/125245">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/namuyu-s-portfolio.appspot.com/o/blog3.jpg?alt=media&token=52a876b0-aa69-4fff-8c04-cc12a50a1dbb"
            />
          </a>
          <h4>
            それは置いといて
            <br />今週末応用技術者試験受けます。
          </h4>
          <p class="date">2018/10/16</p>
          <p>それは置いといて。 今週末10/21はIPA情報処理推進機構の試験の日だ。 その中でぼくは応用技術者試験を受ける。 先週までは統計検定1級の勉強ばかりやってたけれど、もっと前の段階で午前問題は合格点に乗っていたし、午後問題も手に負えていたのでまあ大丈夫だろう、ってところである。</p>
        </div>
      </div>
      <div class="cols">
        <div class="col_both_ends">
          <a href="https://namyusql.hatenablog.com/entry/2018/10/11/172040">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/namuyu-s-portfolio.appspot.com/o/blog2.jpg?alt=media&token=451e48bb-a804-41df-9b84-32c17dfa58a6"
            />
          </a>
          <h4>統計検定1級を受験します。</h4>
          <p class="date">2018/10/11</p>
          <p>ぼくは来月の24日に、統計検定の1級を受けようと考えている。 それにあたって、これまでも統計検定関連のブログはいくつか見てきたけど、割とレベルが高い人が多くて「そりゃ合格するだろ」と感じていた。 一方で自分はというと大学で統計学の講義は受けたけど期末試験は計算系の問題、他にゴリゴリ数学の証明問題を解くような経験はなく、統計検定2級は計算のやり方を覚えて合格をした程度のレベルである。</p>
        </div>
        <div class="col_both_ends">
          <a href="https://namyusql.hatenablog.com/entry/2018/10/04/160258">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/namuyu-s-portfolio.appspot.com/o/blog1.jpg?alt=media&token=804c6188-5f1f-4aed-9847-cc1eb86b0adc"
            />
          </a>
          <h4>
            ボイスコッド正規形について
            <br />自分用まとめ その２
          </h4>
          <p class="date">2018/10/4</p>
          <p>前回はボイスコッド正規形について、特徴、メリット、作り方といった基礎的な内容について書いた。 今回は、その補足的なトピックとして、ボイスコッド正規形を作る際に気を付けるべきことと、ボイスコッド正規形で起きうる問題について取り扱う。</p>
        </div>
      </div>
      <a href="https://namyusql.hatenablog.com/">
        All Posts are here
        <i class="zmdi zmdi-chevron-right zmdi-hc-lg"></i>
      </a>
    </section>
    <footer>
      <div class="float_container">
        <a href="https://twitter.com/namuyuy">
          <i class="zmdi zmdi-twitter-box zmdi-hc-lg"></i>
        </a>
        <a href="https://github.com/Namuyu">
          <i class="zmdi zmdi-github-box zmdi-hc-lg"></i>
        </a>
      </div>
      <p>
        <span>Namuyu</span>’s Porfolio Site
        <br />Copyright © Namuyu 2019
      </p>
    </footer>
  </div>
</template>

<script>
import Title from "./components/Title.vue";
import Colorbar from "./components/Colorbar.vue";

export default {
  name: "app",
  components: {
    Title,
    Colorbar
  },
  data() {
    return { decorations_number: this.calcurateDecorationsNumber() };
  },
  mounted() {
    window.addEventListener("resize", this.changeDecorationsNumber);
  },
  methods: {
    changeDecorationsNumber() {
      this.decorations_number = this.calcurateDecorationsNumber();
    },
    calcurateDecorationsNumber() {
      return Math.round(window.innerWidth / 50);
    }
  }
};
</script>

<style>
#app {
  font-family: -apple-system, blinkMacSystemFont, "Helvetica Neue", "Segoe UI",
    "ヒラギノ角ゴ ProN W3", Meiryo, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}
body {
  margin: 0;
}
section {
  padding: 100px calc((100vw - 1175px) / 2);
  width: 100vw;
  box-sizing: border-box;
}
footer {
  background-color: #303424;
  padding: 70px calc((100vw - 1175px) / 2);
}
footer a {
  float: left;
  padding: 18px;
  background-color: #4e543e;
  margin: 0 20px;
}
footer i {
  color: #fffede;
}
footer p {
  text-align: center;
  color: #fffede;
}
footer p span {
  color: #e89053;
}
h4 {
  font-size: 1.66em;
}
p,
h4,
li {
  text-align: left;
  line-height: 30px;
}
li {
  margin-bottom: 14px;
  list-style-type: none;
  position: relative;
  padding-left: 15px;
}
li:before {
  border-radius: 50%;
  width: 5px;
  height: 5px;
  position: absolute;
  left: 0;
  top: 12px;
  content: "";
  background: #e89053;
}
#decoration_bar {
  overflow: hidden;
  margin-right: -50px;
}
.decoration {
  width: 50px;
  height: 6px;
  float: left;
}
.decoration:nth-of-type(5n + 1) {
  background-color: #e89053;
}
.decoration:nth-of-type(5n + 2) {
  background-color: #fffdca;
}
.decoration:nth-of-type(5n + 3) {
  background-color: #a3e055;
}
.decoration:nth-of-type(5n + 4) {
  background-color: #317393;
}
.decoration:nth-of-type(5n + 5) {
  background-color: #993137;
}
.top_title h2,
.top_title h3 {
  color: #fffede;
}
.center {
  margin-left: auto;
  margin-right: auto;
  float: none;
}
.main_contents {
  clear: both;
}
.main_contents:nth-of-type(odd) {
  background-color: #ffffe7;
}
.cols {
  clear: both;
  overflow: hidden;
}
.col_both_ends {
  float: left;
  width: 400px;
}
.col_2rows {
  padding: 15px;
  box-sizing: border-box;
}
.float_container {
  overflow: hidden;
  width: 100%;
}
@media (min-width: 1175px) {
  .col_both_ends:nth-of-type(2) {
    float: right;
  }
  .col_2rows {
    float: left;
    width: 50%;
  }
  .col_3rows {
    margin-top: 70px;
    float: left;
    width: calc(100% / 3);
  }
}
@media (max-width: 1175px) {
  .col_2rows {
    width: 600px;
  }
  .col_3rows {
    width: 400px;
  }
  .col_2rows h4,
  .col_3rows h4 {
    text-align: center;
  }
  .col_both_ends,
  .col_2rows,
  .col_3rows {
    float: none;
    margin-left: auto;
    margin-right: auto;
  }
  .float_container {
    text-align: center;
  }
  .float_container a {
    float: none;
    display: inline-block;
  }
}
#top {
  background-color: #303424;
  padding: 0;
  display: flex;
  height: 100vh;
}
#top .top_title {
  margin: auto;
}
#creations img {
  width: 100px;
  height: 100px;
}
#blogs img {
  width: 400px;
  height: 300px;
}
#blogs a {
  float: right;
  font-size: 2em;
  margin-right: 20px;
}
#blogs a:link,
p a:link {
  color: #e89053;
}
#blogs a:visited,
p a:visited {
  color: #993137;
}
#blogs a i {
  padding: 0 0 0 5px;
}
</style>
